// extracted by mini-css-extract-plugin
export var image = "secondary-block-module--image--f40e7";
export var isActive = "secondary-block-module--isActive--7ed71";
export var link = "secondary-block-module--link--e10ab";
export var secondaryBlock = "secondary-block-module--secondaryBlock--42e0d";
export var svgImage = "secondary-block-module--svgImage--284e0";